import 'css-chunksrc/client/scenes/wbs/secondaryCriteria/styles.scss';export default {
  "secondaryCriteria": "_secondaryCriteria_1kb3g_1",
  "row": "_row_1kb3g_8",
  "flexContainer": "_flexContainer_1kb3g_23",
  "spacer": "_spacer_1kb3g_29",
  "comment": "_comment_1kb3g_33",
  "file": "_file_1kb3g_37"
};